__turbopack_context__.v({
  "blink": "complex-module-scss-module__9cBnDW__blink",
  "column": "complex-module-scss-module__9cBnDW__column",
  "columns2": "complex-module-scss-module__9cBnDW__columns2",
  "columns3": "complex-module-scss-module__9cBnDW__columns3",
  "columns4": "complex-module-scss-module__9cBnDW__columns4",
  "complex": "complex-module-scss-module__9cBnDW__complex",
  "firstColumn": "complex-module-scss-module__9cBnDW__firstColumn",
  "secondColumn": "complex-module-scss-module__9cBnDW__secondColumn",
});
